import * as d3 from 'd3';
import { dN_Rect } from './d_rect';
import { drawHinge } from './drawHinge';
import { drawGrills } from './drawGrills';
import { drawTilt } from './drawTilt';
import { drawArrow } from './drawArrow';
import { getGlassDesign } from './glassPatternsDefs';


export function drawSingleSlideTilt(nSections = 5, indexWindow = 1,
    svg, d = 2, initX = 20, initY = 20, frameWidth = 10, doorData = null, top = false, OneSection = false)
  {
    const frameData = doorData?.frameData;
    const finish = doorData?.finish;
    const finishColor = doorData.flipped ? doorData?.finish?.exteriorColor?.value || 'white' :
                                           doorData?.finish?.interiorColor?.value || 'white' ;
  
    // Access type dynamically
    let type = 'type';
    let windowHeight = parseFloat(frameData.windowHeight_d); 
    if (top){
        type = 'typeTop';
        windowHeight = parseFloat(frameData?.uHeight_d || 0); 
    }
    const typeKey = `${type}${indexWindow}`;
    const widthKey = `windowWidth${indexWindow}_d`;
    const shapeKey = `shape${indexWindow}`;
    const shape = frameData?.[shapeKey] || 'Rectangle';

    if (frameData?.[typeKey] === 'Single Slider Tilt') {
        let windowWidth = parseFloat(frameData[widthKey]);
        //const windowHeight = parseFloat(frameData.windowHeight_d) - 2*d;
  
        let adjustedWidth = (windowWidth - 2*d  - frameWidth * 2) / 2;
  
        let xOffset = initX ;
        for (let i = 1; i < indexWindow; i++) {
            const key = `windowWidth${i}_d`;
            xOffset += parseFloat(frameData[key] || 0) + 2 * frameWidth + 2*d;
        }
        
      
        const glassType = `glassType${indexWindow}`;
        const glassColor = doorData?.glass?.[glassType].value || 'white'; 

        if (OneSection){
            xOffset = initX;
            windowWidth = parseFloat(frameData?.uWidth1_d)  - 
            2 * frameWidth - 2*d + parseInt(nSections);
            adjustedWidth = (windowWidth - 2 * frameWidth)*0.5;
        }
        const glassDesign = getGlassDesign(doorData);
        if (1) { //(shape === 'Rectangle') {
            dN_Rect(svg, d, xOffset , initY, [
                {
                    w: windowWidth/2  + 0,
                    h: windowHeight + 0*d,
                    color: glassColor || 'lightblue',
                    glassType: doorData?.glass?.glassType1.label,
                    glassDesign: glassDesign,
                    frameWidth: 0,
                    frameColor: finishColor,
                    lineFrameColor: 'black',
                    lineFrameThickness: 1,
                    outerStrokeColor: 'black',
                    outerStrokeWidth: 1
                },
                {
                    w: windowWidth/2 -2*d,
                    forceSubFrame: true,

                    h: windowHeight + 2*d - 2*d - 1,
                    color: glassColor || 'lightblue',
                    glassType: doorData?.glass?.glassType1.label,
                    glassDesign: glassDesign,
                    frameWidth,
                    frameColor: finishColor,
                    lineFrameColor: 'black',
                    lineFrameThickness: 1,
                    outerStrokeColor: 'black',
                    outerStrokeWidth: 1,
                    fullCorners: true,
                    displayLabel:  false
                }
            ], {
                labelText: `\u00A0✔`,
                subFrame: false,
                labelOptions: {
                    fontSize: 16,
                    fontColor: 'green',
                    fontOpacity: 0.2
                },
                drawFrame: true
            });
        }
        
        drawGrills(svg, indexWindow,
                xOffset, 
                initY, 
                windowWidth/2 -frameWidth/2, 
                windowHeight + 2*d, 
                frameWidth,
                doorData, top);

        drawGrills(svg, indexWindow,
                    xOffset + adjustedWidth + 2* frameWidth -d , 
                    initY, 
                    windowWidth/2 -2*d - 1, 
                    windowHeight + 2*d, 
                    frameWidth, 
                    doorData, top);
      
        if (0){
            drawHinge(svg, xOffset + d, initY, adjustedWidth, windowHeight, frameWidth,                     
            1,  // hingeType: 1 = left, 2 = right
            'red'); 
            drawHinge(svg, xOffset + d + adjustedWidth + 2* frameWidth + d, initY, adjustedWidth, windowHeight, frameWidth,                     
            2,  // hingeType: 1 = left, 2 = right
            'red');
        }
        if (false) {//draw left Tilt 
            drawTilt(svg, xOffset + d, initY, adjustedWidth + 2*d, windowHeight + d, frameWidth, 'red'); 
         }
        if (true) {//draw right Tilt
            drawTilt(svg, xOffset + windowWidth/2 + frameWidth/2, 
                          initY - d, 
                          windowWidth/2 -2*d - 1, //adjustedWidth + 2*d + 1, 
                          windowHeight + d, 
                          frameWidth);
        }
        drawArrow(svg, xOffset + d, initY, adjustedWidth + 2*d, windowHeight + d, frameWidth, 'green', 'toLeft');
  
    }
  }//drawSingleSlideTilt